import { AddDecisionMember } from ".";
import { Button } from "../../Button";
import { ConfirmationModal } from "../../ConfirmationModal";
import { deleteDecisionMembers, getDecisionMembers } from "../../../api/decision/decision-members";
import { ModalHeader } from "../../ModalHeader";
import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import {
	StyledDecisionMakers,
	StyledDecisionMakerUnitsContainer,
	StyledDecisionMakerUnitsFooter,
} from "../../../styles/StyledDecision/StyledContent";
import { StyledModal } from "../../../styles/StyledModal";
import { UnitCard } from "../../UnitList/UnitCard";
import { useDecisionContext } from "../../../context/decisionContext";
import { useQuery } from "react-query";
import { useState } from "react";
import AddIcon from "../../../assets/img/icons/add.svg";
import convertStringToColor from "../../../helpers/util/convertStringToColor";
import Modal from "react-modal";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function DecisionReceivers({ isMaker = false, newDecision = false }) {
	const { id } = useDecisionContext();
	const { axiosPrivate } = useAxiosPrivate();

	// For new decisions, don't make API calls
	const shouldFetchData = !newDecision && id;
	const { isLoading, isError, error, data, refetch } = shouldFetchData
		? useQuery(["decisionMembers", id], () => getDecisionMembers(axiosPrivate, id))
		: { isLoading: false, isError: false, error: null, data: [], refetch: () => {} };
	const [openDropdowns, setOpenDropdowns] = useState({});

	const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);

	const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);

	// Compute result units directly without useEffect to avoid infinite loops
	const resultUnits = newDecision ? [] : (Array.isArray(data) ? data : []);

	// Log errors without causing re-renders
	if (isError && !newDecision) {
		console.log(error);
	}

	const openConfirmModal = (id) => {
		setDeletedId(id);
		setIsConfirmModalOpen(true);
	};

	const closeConfirmModal = () => {
		setIsConfirmModalOpen(false);
		setDeletedId(null);
	};

	const handleDelete = async (memberId) => {
		await deleteDecisionMembers(axiosPrivate, refetch, isMaker, id, memberId);
	};

	// const people = [
	// 	{ id: 1, name: "Maria Svensson", position: "Dean of the multimedia departament" },
	// 	{ id: 2, name: "Anna Smith", position: "District Marketing Assistant" },
	// 	{ id: 3, name: "John Gordonsson", position: "Future Solutions Manager" },
	// 	{ id: 4, name: "Henry Franecki", position: "Principal Division Strategist" },
	// 	{ id: 5, name: "Dianna Crist", position: "Customer Web Developer" },
	// 	{ id: 6, name: "Ann Rau", position: "Forward Optimization Executive" },
	// 	{ id: 7, name: "Wilma Hickle", position: "Future Division Orchestrator" },
	// 	{ id: 8, name: "Maria Svensson", position: "Dean of the multimedia departament" },
	// 	{ id: 9, name: "Anna Smith", position: "District Marketing Assistant" },
	// 	{ id: 10, name: "John Gordonsson", position: "Future Solutions Manager" },
	// 	{ id: 11, name: "Henry Franecki", position: "Principal Division Strategist" },
	// 	{ id: 12, name: "Dianna Crist", position: "Customer Web Developer" },
	// 	{ id: 13, name: "Ann Rau", position: "Forward Optimization Executive" },
	// 	{ id: 14, name: "Wilma Hickle", position: "Future Division Orchestrator" },
	// ];

	// for (const person of people) {
	// 	if (openDropdowns["p" + person.id] === undefined) setOpenDropdowns({ ...openDropdowns, ["p" + person.id]: false });
	// }

	const units = [
		{ id: 1, name: "UnivX Board" },
		{ id: 2, name: "First departament" },
		{ id: 3, name: "Second departament" },
		{ id: 4, name: "A great unit for demonstration!" },
	];

	for (const unit of units) {
		if (openDropdowns[unit.id] === undefined) setOpenDropdowns({ ...openDropdowns, [unit.id]: false });
	}

	return (
		<>
			<StyledDecisionMakers>
				<StyledDecisionMakerUnitsContainer>
					{isLoading || isError ? (
						<QueryLoader />
					) : (
						resultUnits.map((e) => {
							return (
								<UnitCard
									key={e.id}
									id={e.id}
									name={e.name}
									state={"delete"}
									color={convertStringToColor(e.name)}
									openDropdowns={openDropdowns}
									setOpenDropdowns={setOpenDropdowns}
									direction={"right"}
									moreActionsPosition={"absolute"}
									deleteFunc={openConfirmModal}
								/>
							);
						})
					)}
				</StyledDecisionMakerUnitsContainer>
				{/* <StyledDecisionMakerMembersContainer>
					<h4>Members</h4>
					{people.map((e, i) => {
						return (
							<UserCard
								key={i}
								data={e}
								color={convertStringToColor(e.name)}
								openDropdowns={openDropdowns}
								setOpenDropdowns={setOpenDropdowns}
								direction={"right"}
								moreActionsPosition={"absolute"}
							/>
						);
					})}
				</StyledDecisionMakerMembersContainer> */}
				<StyledDecisionMakerUnitsFooter>
					<Button
						onClick={() => {
							setIsUnitModalOpen(true);
						}}
						icon={AddIcon}
					>
						Add unit
					</Button>
					{/* <Button icon={AddIcon}>Add receiver</Button> */}
				</StyledDecisionMakerUnitsFooter>
			</StyledDecisionMakers>
			<Modal
				isOpen={isUnitModalOpen}
				onRequestClose={() => {
					setIsUnitModalOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setIsUnitModalOpen(false);
					}}
				>
					Add Decision {isMaker ? "Maker" : "Receiver"}
				</ModalHeader>
				{!isLoading && !isError && (
					<AddDecisionMember
						onClick={() => {
							setIsUnitModalOpen(false);
						}}
						isMaker={isMaker}
						refetch={refetch}
					/>
				)}
			</Modal>
			<Modal isOpen={isConfirmModalOpen} onRequestClose={closeConfirmModal} style={StyledModal} appElement={document.getElementById("app")}>
				<ConfirmationModal handleDelete={handleDelete} deletedId={deletedId} closeModal={closeConfirmModal} />
			</Modal>
		</>
	);
}

DecisionReceivers.propTypes = {
	isMaker: PropTypes.bool,
	newDecision: PropTypes.bool,
};
